/* eslint-disable no-console */

import mixpanel from 'mixpanel-browser';

import { store } from '@core/store';

import Event from './events';

import packageJson from '../../../../package.json';

const appVersion = packageJson.version;

/** `source` on Mixpanel payloads from this web client (matches other `sendMixpanelEvent` usage). */
export const MIXPANEL_WEB_SOURCE = 'Web';

// To initialize the mixpanel instance
export const initMixpanel = () => {
  const token = process.env.REACT_APP_PUBLIC_MIXPANEL_TOKEN;

  if (!token || token.trim() === '') {
    return;
  }

  try {
    mixpanel.init(token, {
      ignore_dnt: true,
      track_pageview: false
    });
  } catch (error) {
    console.warn('Mixpanel initialization failed:', error);
  }
};

const isInternalUser = (): boolean => {
  try {
    const state: any = store.getState();
    return Boolean(state?.user?.currentUser?.is_internal);
  } catch (e) {
    return false;
  }
};

// To track mixpanel event
export const sendMixpanelEvent = (
  event: string,
  data?: Record<string, unknown>
) => {
  if (
    !process.env.REACT_APP_PUBLIC_MIXPANEL_TOKEN ||
    process.env.REACT_APP_PUBLIC_MIXPANEL_TOKEN.trim() === ''
  ) {
    return;
  }

  const allowEvents = process.env.REACT_APP_MIXPANEL_INTERNAL_EVENTS;
  if (isInternalUser() && allowEvents !== 'true') {
    return;
  }

  try {
    mixpanel.track(event, { ...data, app_version: appVersion });
  } catch (error) {
    console.warn('Mixpanel event tracking failed:', error);
  }
};

export const trackPageView = (pageName: string, data = {}) => {
  if (
    !process.env.REACT_APP_PUBLIC_MIXPANEL_TOKEN ||
    process.env.REACT_APP_PUBLIC_MIXPANEL_TOKEN.trim() === ''
  ) {
    return;
  }

  const allowEvents = process.env.REACT_APP_MIXPANEL_INTERNAL_EVENTS;
  if (isInternalUser() && allowEvents !== 'true') {
    return;
  }

  try {
    mixpanel.track_pageview({
      page: pageName,
      ...data,
      app_version: appVersion
    });
  } catch (error) {
    console.warn('Mixpanel page view tracking failed:', error);
  }
};

export const setUserProperties = (
  identity: string,
  userProperties: Record<string, unknown>
) => {
  if (
    !process.env.REACT_APP_PUBLIC_MIXPANEL_TOKEN ||
    process.env.REACT_APP_PUBLIC_MIXPANEL_TOKEN.trim() === ''
  ) {
    return;
  }

  if (isInternalUser()) {
    return;
  }

  try {
    mixpanel.identify(identity);
    Object.entries(userProperties).forEach(([key, value]) => {
      mixpanel.people.set(key, value);
    });
  } catch (error) {
    console.warn('Mixpanel user properties setting failed:', error);
  }
};

export { Event };
